<template>
    <HeadlessTransitionRoot appear :show="show" as="template">
        <HeadlessDialog as="div" @close="closeDialog" class="relative z-[1000]">
            <HeadlessTransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-black bg-opacity-60" />
            </HeadlessTransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <component
                    v-bind="$attrs"
                    :is="dialog"
                    :closeable="closeable"
                    :title-icon="titleIcon"
                    :title="title"
                    @close="closeDialog"
                    :error="error"
                    :icon-class="iconClass"
                >
                    <template #header v-if="hasCustomHeader">
                        <slot name="header" />
                    </template>
                    <slot name="default" />
                </component>
            </div>
        </HeadlessDialog>
    </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
// * interfaces
interface Props {
    show: boolean;
    title?: string;
    titleIcon?: string;
    closeable?: boolean;
    error?: boolean;
    iconClass?: string;
}

// * composables
const { breakpoint } = useResponsive();

// * props
const props = withDefaults(defineProps<Props>(), {
    show: false,
    closeable: true,
    title: undefined,
});

// * slots
const slots = useSlots();

// * emits
const emit = defineEmits(["close"]);

// * computed properties
const hasCustomHeader = computed(() => {
    return !!slots.header;
});
const dialog = computed(() => {
    return breakpoint.value == "desktop" || breakpoint.value === "tablet"
        ? defineAsyncComponent({ loader: () => import("~/components/app-dialog/AppModal.vue") })
        : defineAsyncComponent({ loader: () => import("~/components/app-dialog/AppBottomSheet.vue") });
});

// * methods
function closeDialog() {
    if (props.closeable) {
        emit("close");
    }
}
</script>

<style lang="scss"></style>
